import React from 'react'
import classes from "./QuestionMark.module.css"
import { QuestionMarkIcon } from '../../../constant'
import clsx from 'clsx'
const QuestionMarkButton = ({className,...rest}) => {
  return (
    <span className={clsx(classes.button,className)} {...rest}>
        <QuestionMarkIcon />
    </span>
  )
}

export default QuestionMarkButton